import axios from "axios";
import io from 'socket.io-client';

const connectionOptions = {
    "force new connection": true,
    reconnectionAttempts: "Infinity", // avoid having user reconnect manually in order to prevent dead clients after a server restart
    timeout: 10000, // before connect_error and connect_timeout are emitted.
    transports: ["polling"]
};

const tokens = localStorage.getItem("APUSEC");
let AUTH_TOKEN;
if (tokens) {
    AUTH_TOKEN = tokens;
}

/* Localhost URL CONFIG */
// export const NodeURL = "http://localhost:3066";
// export const SubdomainURL = "localhost:3005";

/* LIVE URL CONFIG */
export const SubdomainURL = "getshifts.co.uk";
export const NodeURL = "https://www.getshifts.co.uk";

/* STAGING URL CONFIG */
// export const SubdomainURL = "apstaging.co.uk";
// export const NodeURL = "https://www.apstaging.co.uk";

export const socket_chat = io(`${NodeURL}/chat`, {});
export const socket_notify = io(`${NodeURL}/notify`, {});
export const socket = io(`${NodeURL}`, {});

export const client = axios.create({
    baseURL: NodeURL
});
client.defaults.headers.common["Authorization"] = AUTH_TOKEN;
client.defaults.responseType = "json";
const request = options => {
    const onSuccess = response => {
        /*
           SESSION HANDLING:
               - When Server returns "00" -> which means the session has expired  
               - Pushes the URL to Login Page -> "www.getshifts.co.uk/admin"
        */
        if (response.data.status === "00") {
            // window.location = "/candidate/login"
            localStorage.removeItem("APUSEC");
        }
        return response.data; // This in turn returns data to be shown in the frontend
    };
    const onError = error => {
        if (error.response) {
            // Request was made but server responded with something other than 2xx
        } else {
            // Something else happened while setting up the request triggered the error
        }
        return Promise.reject(error.response || error.message);
    };
    return client(options)
        .then(onSuccess)
        .catch(onError);
};
export default request;
